import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { SwiperClass, SwiperSlide } from 'swiper/react'

import install1 from '@/assets/images/main-sec3-install-01-playstore-app.png'
import install2 from '@/assets/images/main-sec3-install-02-run-app.png'
import install3 from '@/assets/images/main-sec3-install-03-permission.png'
import install4 from '@/assets/images/main-sec3-install-04-auth.png'
import install5 from '@/assets/images/main-sec3-install-05-join.png'
import install6 from '@/assets/images/main-sec3-install-06-set-pin.png'
import install7 from '@/assets/images/main-sec3-install-07-emergency-and-backup.png'
import used1 from '@/assets/images/main-sec3-used-01-visit-site.png'
import used2 from '@/assets/images/main-sec3-used-02-login.png'
import used3 from '@/assets/images/main-sec3-used-03-lockmode.png'
import used4 from '@/assets/images/main-sec3-used-04-feature.png'
import arrowSrc from '@/assets/images/sec3_arrow.png'
import { CustomSwiper } from '@/shared/components/ui/Swiper'
import { Nanum_eb_size, Nanum_r_size } from '@/styles/font/NanumSquare'
import { mediaTablet } from '@/styles/mediaQuery'
import { icoSet } from '@/styles/mixins'

const imageMap: Record<string, string> = {
  'install-01-playstore-app': install1,
  'install-02-run-app': install2,
  'install-03-permission': install3,
  'install-04-auth': install4,
  'install-05-join': install5,
  'install-06-set-pin': install6,
  'install-07-emergency-and-backup': install7,
  'used-01-visit-site': used1,
  'used-02-login': used2,
  'used-03-lockmode': used3,
  'used-04-feature': used4,
}

interface StepSwiperProps {
  selectedIdx: number
}

const StepSwiper = ({ selectedIdx }: StepSwiperProps) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [swiperInstance, setSwiperInstance] = useState<SwiperClass | null>(null)

  const { swiperContent, classNamePrefix } = swiperData[selectedIdx]

  useEffect(() => {
    setActiveIndex(0)
    swiperInstance?.slideTo(0, 400)
  }, [selectedIdx, swiperInstance])

  return (
    <CustomSwiper.Wrap
      type="default"
      onActiveIndexChangeFn={setActiveIndex}
      swiperOption={{
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: false,
      }}
      onSwiper={setSwiperInstance}
    >
      {swiperContent.map((data, idx) => (
        <SwiperItemsWrap key={idx}>
          <SwiperItemSection>
            <StepImg src={imageMap[data.imageName]} alt={data.alt} className={classNamePrefix} />
            <StepTextWrap className={classNamePrefix}>
              <SwiperPagination>
                {idx + 1}/{swiperContent.length}
              </SwiperPagination>
              <TextWrap className={classNamePrefix}>
                <SwiperText>{data.title}</SwiperText>
                {data.description && (
                  <SwiperDescriptionText>{data.description}</SwiperDescriptionText>
                )}
              </TextWrap>
            </StepTextWrap>
          </SwiperItemSection>
        </SwiperItemsWrap>
      ))}
      <SwiperButton
        onClick={() => swiperInstance?.slidePrev()}
        className={`prev ${classNamePrefix}`}
        $hide={activeIndex === 0}
      />
      <SwiperButton
        onClick={() => swiperInstance?.slideNext()}
        className={`next ${classNamePrefix}`}
        $hide={activeIndex === swiperContent.length - 1}
      />
    </CustomSwiper.Wrap>
  )
}

export default StepSwiper

const swiperData = [
  {
    classNamePrefix: 'install',
    swiperContent: [
      {
        title: '구글플레이 스토어를 통해 ‘휴대폰분실보호’ 앱을 설치하세요.',
        description: '아이폰 사용자용 서비스는 추후 업데이트 될 예정입니다.',
        imageName: 'install-01-playstore-app',
        alt: '구글플레이스토어에서 앱 설치',
      },
      {
        title: '설치 완료 되면, ‘휴대폰분실보호’ 앱을 실행하세요.',
        imageName: 'install-02-run-app',
        alt: '앱 실행',
      },
      {
        title: '기능별 접근권한을 모두 허용해주세요.',
        imageName: 'install-03-permission',
        alt: '접근 권한 설정',
      },
      {
        title: '본인 확인을 위해 휴대폰 인증을 진행해 주세요.',
        imageName: 'install-04-auth',
        alt: '본인 인증',
      },
      {
        title: '이용약관 동의 후 서비스 가입을 완료하세요.',
        imageName: 'install-05-join',
        alt: '이용약관 동의 및 가입',
      },
      {
        title: 'PIN번호를 설정하세요 : 잠금모드 해제, [분실폰 찾기] 로그인시 사용됩니다.',
        imageName: 'install-06-set-pin',
        alt: 'PIN번호 설정',
      },
      {
        title: '습득자가 연락할 수 있도록 비상연락처를 설정해주세요.',
        description: '데이터 백업/복원을 이용하기 위해서 구글 드라이브 연동이 필요합니다.',
        imageName: 'install-07-emergency-and-backup',
        alt: '비상연락처 등록 및 구글 드라이브 연동',
      },
    ],
  },
  {
    classNamePrefix: 'used',
    swiperContent: [
      {
        title: '휴대폰분실보호 [분실폰 찾기] 웹사이트 ( https://svc.mfinder.co.kr) 에 접속합니다.',
        imageName: 'used-01-visit-site',
        alt: '분실폰 찾기 웹사이트 접속 ',
      },
      {
        title:
          '서비스 가입된 휴대폰 번호와 앱 설치시 등록한 PIN번호 6자리를 입력 후, 로그인 하세요.',
        imageName: 'used-02-login',
        alt: '분실폰 찾기 웹사이트 로그인',
      },
      {
        title: '로그인과 동시에, 서비스에 가입된 휴대폰은 잠금모드가 실행됩니다.',
        imageName: 'used-03-lockmode',
        alt: '	분실폰 잠금모드 실행',
      },
      {
        title: '휴대폰분실보호 서비스가 제공하는 기능을 이용해 분실폰을 쉽고 빠르게 찾아보세요.',
        imageName: 'used-04-feature',
        alt: '분실폰 기능 사용 예시',
      },
    ],
  },
]

const SwiperItemSection = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const SwiperItemsWrap = styled(SwiperSlide)`
  width: 100% !important;
`
const SwiperPagination = styled.div`
  width: 120px;
  padding: 8px 15px;
  margin: 0 auto;
  letter-spacing: 2.5px;

  &:before {
    content: 'Step';
    display: inline-block;
    margin-right: 5px;
    vertical-align: middle;
    letter-spacing: -0.5px;
  }

  ${Nanum_eb_size(20)};
  border-radius: 25px;
  background-color: var(--gray-f4);

  ${mediaTablet} {
    ${Nanum_eb_size(12)};
  }
`
const SwiperButton = styled.button<{ $hide?: boolean }>`
  background-image: url(${arrowSrc});
  ${icoSet}
  width: 68px;
  height: 68px;
  position: absolute;
  top: 259px;
  z-index: 10;
  display: ${({ $hide }) => ($hide ? 'none' : 'block')};

  ${mediaTablet} {
    width: 33px;
    height: 33px;
    top: 150px;

    &.used {
      top: 90px;
    }
  }

  &.prev {
    transform: rotate(180deg);
    left: 23%;

    ${mediaTablet} {
      left: 0;
    }

    &.used {
      left: 16%;

      ${mediaTablet} {
        left: 0px;
      }
    }
  }

  &.next {
    right: 23%;

    ${mediaTablet} {
      right: 0;
    }

    &.used {
      right: 16%;

      ${mediaTablet} {
        right: 0px;
      }
    }
  }
`
const StepTextWrap = styled.div`
  display: flex;
  flex-direction: column;

  &.used {
    margin-top: 40px;
  }

  ${mediaTablet} {
    margin-top: 0;

    &.used {
      margin-top: 80px;
    }
  }
`
const TextWrap = styled.div`
  &.used {
    margin-top: 35px;

    ${mediaTablet} {
      margin-top: 5px;
    }
  }
`
const SwiperText = styled.p`
  ${Nanum_r_size(20)}
  color: var(--gray-28);
  margin: 13px 0 12px;

  ${mediaTablet} {
    ${Nanum_r_size(14)}
    margin: 26px 0 8px;
  }
`
const SwiperDescriptionText = styled.p`
  color: var(--red);

  ${mediaTablet} {
    ${Nanum_r_size(12)}
  }
`

const StepImg = styled.img`
  width: 361px;
  height: 604px;

  ${mediaTablet} {
    width: 202px;
    height: 339px;
  }

  &.used {
    width: 962px;
    height: 529px;

    ${mediaTablet} {
      width: 312px;
      height: 172px;
    }
  }
`
